
                export default function (Component) {
                    Component.__source = "library/components/VabNav/index.vue"
                }
            